<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E%E7%B7%A8%E8%BC%AF%E9%8A%80%E8%A1%8C%E5%B8%B3%E6%88%B6 -->
<!-- 新增編輯銀行帳戶 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="coopBank"
                :id="id"
                labelPosition="top"
                formTitle="銀行帳戶管理"
                :rules="rules"
                :recordToEdit="recordToEdit"
                :formType="formType"
            ></ListForm>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "bank_account_edit",
    components: {
        ListForm
    },
    props: {},
    data() {
        return {
            id: this.$route.params.id == "new" ? 0 : this.$route.params.id,
            recordToEdit: {},
            bankList: "",
            formType: [
                {
                    label: "銀行代號(輸入代號或名稱)",
					key: "bankCode",
					type: "remoteselect",
					filterable: true,
					remote: true,
					loading: false,
					value: [],
					options: [],
					list: [],
					states: [],
					placeholder: "請輸入代號或名稱"
                },
                {
                    label: "銀行名稱",
                    key: "bankName",
                    type: "input"
                },
                {
                    label: "電話",
                    key: "bankPhone",
                    type: "input"
                },
                {
                    label: "地址",
                    key: "bank",
                    type: "address"
                },
                {
                    label: "開戶全銜",
                    key: "accountName",
                    type: "input"
                },
                {
                    label: "帳戶種類",
                    key: "accountType",
                    type: "input"
                },
                {
                    label: "帳戶號碼",
                    key: "accountNumber",
                    type: "input"
                },
                {
                    label: "對應活存會計科目",
                    key: "ddAccountTitleId",
                    type: "select",
                    filterable: true,
                    options: []
                },
                {
                    key: "sealCoop",
                    type: "checkbox",
                    options: [
                        {
                            label: "社印"
                        }
                    ]
                },
                {
                    key: "sealManager",
                    type: "checkbox",
                    options: [
                        {
                            label: "理事長印"
                        }
                    ]
                },
                {
                    key: "sealTreasure",
                    type: "checkbox",
                    options: [
                        {
                            label: "司庫印"
                        }
                    ]
                },
                {
                    key: "sealOther",
                    type: "checkbox",
                    options: [
                        {
                            label: "其它印"
                        }
                    ]
                }
            ],
            rules: {
                bankCode: [
                    { required: true, message: "請輸入代號", trigger: "blur" }
                ],
                bankName: [
                    { required: true, message: "請輸入名稱", trigger: "blur" }
                ],
                accountName: [
                    { required: true, message: "請輸入全銜", trigger: "blur" }
                ],
                accountType: [
                    { required: true, message: "請輸入種類", trigger: "blur" }
                ],
                accountNumber: [
                    {
                        required: true,
                        message: "請輸入帳戶號碼",
                        trigger: "blur"
                    }
                ],
                ddAccountTitleId: [
                    {
                        required: true,
                        message: "請選擇活存會計科目",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    created() {
        this.getData();
        this.getBankList();
    },
    methods: {
        getData() {
            const url = API.coopBank + `?id=${this.id}`;
            const thenCB = json => {
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData.data.data
                );
                // 對應活存會計科目
                this.formType[7].options = json.resultData.enumData.accountTitleIdDemandDeposit.map(
                    colAccountTitleTitle => {
                        return {
                            label: `${colAccountTitleTitle.code} ${colAccountTitleTitle.name}`,
                            value: colAccountTitleTitle.id
                        };
                    }
                );
                // this.formType[0].states = json.resultData.enumData.accountTitleId112.map(
                //     colAccountTitleTitle => {
                //         return {
                //             label: `${colAccountTitleTitle.code} ${colAccountTitleTitle.name}`,
                //             value: colAccountTitleTitle.id
                //         };
                //     }
                // );
            };
            this.mAxiosGet(url, thenCB);
        },
        getBankList() {
            const url = API.bankCode;
            const thenCB = json => {
                this.formType[0].states = json.resultData.data.map(item => {
                    return {
                        label: `${
                            item.branchCode ? item.branchCode : item.bankCode
                        } ${item.name}`,
                        value: `${item.bankCode} ${item.branchCode}`
                    };
                });
                this.formType[0].options = this.formType[0].states.filter(
                    item => {
                        if (
                            item.value.indexOf(
                                `${this.recordToEdit.bankCode.split(" ")[0]}`
                            ) !== -1
                        ) {
                            return item;
                        }
                    }
                );
            };
            this.mAxiosGet(url, thenCB);
        }
    }
};
</script>